import { render, staticRenderFns } from "./MovieSubcategoriesForBeginnersManagement.vue?vue&type=template&id=813cac06&scoped=true&"
import script from "./MovieSubcategoriesForBeginnersManagement.vue?vue&type=script&lang=js&"
export * from "./MovieSubcategoriesForBeginnersManagement.vue?vue&type=script&lang=js&"
import style0 from "./MovieSubcategoriesForBeginnersManagement.vue?vue&type=style&index=0&id=813cac06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813cac06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VDataTable,VSpacer,VTextField,VTooltip})
